import { computed, inject, Injectable, resource } from '@angular/core';
import { PalletItemRepository } from '../repository/pallet-item.repository';
import { routeParamAsNumber } from '@softline/application';
import { PalletItem } from '../types/pallet-item';

@Injectable()
export class PalletItemService {
  readonly #repository = inject(PalletItemRepository);

  readonly id = routeParamAsNumber('id');

  readonly #resource = resource({
    request: () => this.id() ?? undefined,
    loader: async ({ request: id }) => {
      return this.#repository.load(id);
    },
  });

  readonly items = computed(() => this.#resource.value() ?? []);

  async open(item: PalletItem): Promise<PalletItem | null> {
    const result = await this.#repository.open(item);
    this.#resource.set(this.updateItem(result));
    return result;
  }

  async complete(item: PalletItem): Promise<PalletItem> {
    const result = await this.#repository.complete(item);
    this.#resource.set(this.updateItem(result));
    return result;
  }

  private updateItem(item: PalletItem): PalletItem[] {
    const value = this.#resource.value() ?? [];
    const index = value.findIndex((p) => p.palette.id === item.palette.id);
    if (index < 0) return value;

    value[index] = {
      ...value[index],
      ...item,
    };

    return [...value];
  }
}
